import React from 'react';
import SuccessHeader from '../SuccessHeader';
import { Modal } from '../ui/Modal';
import { UserVerificationContent } from './UserVerificationContent';

type UserVerificationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSkip?: () => void;
};

export const UserVerificationModal: React.FC<UserVerificationModalProps> = ({ isOpen, onClose, onSkip }) => {
  const modalHeader = <SuccessHeader title="Account created successfully!" />;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={800} minHeight={500} header={modalHeader}>
      <UserVerificationContent onComplete={onClose} onSkip={onSkip} />
    </Modal>
  );
};
